import { render, staticRenderFns } from "./CCTV.vue?vue&type=template&id=071bbe5d&"
import script from "./CCTV.vue?vue&type=script&lang=js&"
export * from "./CCTV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports